const AvailableFeatureFlags: {
  CART_ACCESSORY_BUNDLE: string;
  CREDIT_LINE_PHONE_FINANCE: string;
  INCODE_WEB_FLOW_CHECKOUT: string;
  IN_CONSOLE_MESSAGES: string;
  PRE_INSTALL_DEVICES: string;
  CLERK_2FA_TOGGLE: string;
  QR_CODE_LOGIN: string;
  USE_ZENDESK_HELP_PAGE: string;
  OPENPAY_DOWNPAYMENT_BY_CASH: string;
  OPENPAY_CARD_CUSTOM_UI: string;
  REUSE_KYC_FLOW: string;
} = {
  CART_ACCESSORY_BUNDLE: "cart_accessory_bundle",
  CREDIT_LINE_PHONE_FINANCE: "credit_line_phone_finance",
  INCODE_WEB_FLOW_CHECKOUT: "incode_web_flow_checkout",
  IN_CONSOLE_MESSAGES: "in_console_messages",
  PRE_INSTALL_DEVICES: "pre_install_devices",
  CLERK_2FA_TOGGLE: "clerk_2fa_toggle",
  QR_CODE_LOGIN: "qr_code_login",
  USE_ZENDESK_HELP_PAGE: "use_zendesk_help_page",
  OPENPAY_DOWNPAYMENT_BY_CASH: "openpay_downpayment_by_cash",
  OPENPAY_CARD_CUSTOM_UI: "openpay_card_custom_ui",
  REUSE_KYC_FLOW: "reuse_kyc_flow",
};

export default AvailableFeatureFlags;
